module.exports = __webpack_public_path__ + "media/images/icons/icon_lock_gray-5d3910f61ea400f9f6e0409b81c294cb.svg";